import { render, staticRenderFns } from "./DistributorEditor.vue?vue&type=template&id=0305281a"
import script from "./DistributorEditor.vue?vue&type=script&lang=js"
export * from "./DistributorEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports